import { render, staticRenderFns } from "./data10.vue?vue&type=template&id=0d6c67ca&scoped=true&"
import script from "./data10.vue?vue&type=script&lang=js&"
export * from "./data10.vue?vue&type=script&lang=js&"
import style1 from "./data10.vue?vue&type=style&index=1&id=0d6c67ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c67ca",
  null
  
)

export default component.exports